import { createObjectSchema, createRecordSchema, createStringSchema } from '@dreryk/react-draft';

import { DocumentTemplateFormBean } from '~libs.desktop.shared.document-template';

export const documentTemplateDraftSchema = createObjectSchema<DocumentTemplateFormBean>({
   documentTemplateValues: createRecordSchema(createStringSchema()),
});

type VisitId = number;
type PrintTemplateId = number;
export type DocumentTemplateDraftToken = 'documentTemplate';
export const getDocumentTemplateDraftToken = (
   visitId: VisitId,
   printTemplateId: PrintTemplateId
): `visit-${VisitId}-${DocumentTemplateDraftToken}-${PrintTemplateId}` =>
   `visit-${visitId}-documentTemplate-${printTemplateId}`;
